import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import classNames from 'classnames';
import { staticText } from '../../../../../utils/staticText';
import { useClientContext } from '../../../../modules/context/client';
import { getClientTranslations } from '../../../../modules/i18n/client.index';
import Button from '../../../Button';

const pictogramSrc =
  'https://mhgprod.blob.core.windows.net/fe-services/content/assets/ti-empty.png';

const Translations = staticText({
  errorMessage: {
    _: 'No results found with your filters',
    'zh-hk': '沒有符合篩選條件的結果',
  },
  helpText: {
    _: 'Looks like the filters are too narrow. Adjust or clear filters to explore more options.',
    'zh-hk': '篩選條件太嚴格了',
  },
  actionText: {
    _: 'See All Results',
    'zh-hk': '查看所有結果',
  },
});

const style = {
  background:
    'linear-gradient(180deg, var(--highlights-blue-light, #E0F4F8) 0%, var(--highlights-green-light, #E8F5E9) 100%)',
  borderRadius: '50%',
};
const widths = 'md:p-[24px]';

type TIErrorResultProps = {
  onClear?: () => void;
};

export const TIEmptyResults: React.FC<TIErrorResultProps> = ({
  onClear,
}: TIErrorResultProps) => {
  const context = useClientContext();
  const t = getClientTranslations(Translations, context);

  return (
    <div className="flex flex-col items-center gap-spacing/gap/y rounded-radius/table border border-borders/default p-spacing/padding/section-y bg-fill/card">
      <div className="flex max-w-general/4-col-width flex-col items-center gap-spacing/gap/soft-12px">
        <div
          className={classNames(widths, 'p-spacing/gap/soft-12px')}
          style={style}
        >
          <CmsImage
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="size-[58px] object-cover object-top"
            src={pictogramSrc}
            alt="Empty results image"
            aria-hidden
            priority
            unoptimized
            width={58}
            height={58}
          />
        </div>
        <h2 className="mhg-alpha-typography-subheading-1">{t.errorMessage}</h2>
        <div className="mhg-alpha-typography-body-1-relaxed text-center text-colors/neutral-gray-800">
          {t.helpText}
        </div>
      </div>
      {!!onClear && (
        <Button type="button" onClick={onClear}>
          {t.actionText}
        </Button>
      )}
    </div>
  );
};
